<template>
  <el-card
    v-if="selectedReservation!=null"
    v-loading="loading"
    :class="['box', 'grow', 'reservation-view-card', !isMobile ? 'scrollable only-y' : '']"
    :style="height"
  >
    <div class="reservation-view-actions">
      <el-button-group class="animated fadeInRight">
        <el-button type="primary" icon="el-icon-edit" :disabled="!isEditable" size="mini" @click="$emit('edit')"></el-button>
        <el-button type="primary" icon="el-icon-s-release" :disabled="!isEditable" size="mini" @click="deleteReservation"></el-button>
      </el-button-group>
    </div>

    <el-row class="reservation-view-header">
      <el-page-header @back="$emit('close');">
        <div slot="title">
          <span class="hidden-sm-and-down"></span>
        </div>
        <div slot="content" class="reservation-view-title-content">
          <span class="fs-20">{{$t('reservation.reservationNumber2')}}{{selectedReservation.id}}</span>
          <span v-if="isB2B" class="reservation-view-b2b-logo"><el-image src="/logo-panorama.png" style="height:16px;"></el-image></span>
        </div>
      </el-page-header>
    </el-row>

    <el-card class="secondary-text reservation-warning" v-if="!isQuantityValid(null)">
      <i class="mdi mdi-alert">&nbsp;</i>
      <span class="fs-14 secondary-text">{{$t('reservation.warningQtyAvailable')}}</span>
    </el-card>

    <el-tabs v-model="tab" class="reservation-view-tabs" @tab-click="handleTabClick">
      <el-tab-pane :label="$t('reservation.overview')" name="overview">
        <ReservationInfos :reservation="selectedReservation"></ReservationInfos>
        <el-divider></el-divider>

        <el-row :gutter="20" class="reservation-detail-row reservation-detail-row--product">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="6">
            <span class="fs-14 secondary-text reservation-detail-label">{{ $t('reservation.productField') }}</span>
          </el-col>
          <el-col :xs="24" :sm="16" :md="12" :lg="12" :xl="12">
            <div class="fs-14 secondary-text reservation-product-value">
              <i class="mdi mdi-barcode-scan" v-if="selectedReservation.product.type==1"></i>
              <span>
                <el-link v-if="selectedReservation.intent === false" @click="openProductInfo">{{selectedReservation.product.name}}</el-link>
                <span v-else>{{selectedReservation.product.name}}</span>
                <span v-if="selectedReservation.product.provider!=null">, <el-link @click="openProvider(selectedReservation.product.provider.id)">{{customerName(selectedReservation.product.provider)}}</el-link></span>
              </span>
              <span class="reservation-product-sub" v-if="inventoryName">{{inventoryName}}</span>
              <span class="reservation-product-sub">{{selectedReservation.product.sku}}</span>
              <UnitFormatVolumeLabel :unit="selectedReservation.product.unit" :uvc="selectedReservation.product.uvc" :format="selectedReservation.product.format" :volume="selectedReservation.product.volume"></UnitFormatVolumeLabel>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="reservation-detail-row">
          <el-col :xs="24" :sm="16" :md="12" :lg="12" :xl="12">
            <div class="reservation-detail-inline">
              <span class="fs-14 secondary-text reservation-detail-label reservation-detail-label--inline">{{$t('reservation.qtyReservedField')}}</span>
              <span class="fs-14 secondary-text reservation-detail-value reservation-detail-value--inline">{{selectedReservation.qty}}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="reservation-detail-row">
          <el-col :xs="24" :sm="16" :md="12" :lg="12" :xl="12">
            <div class="reservation-detail-inline">
              <span class="fs-14 secondary-text reservation-detail-label reservation-detail-label--inline">{{$t('reservation.qtyUsedField')}}</span>
              <span class="fs-14 secondary-text reservation-detail-value reservation-detail-value--inline">{{selectedReservation.quantity.qty_used}}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="reservation-detail-row">
          <el-col :xs="24" :sm="16" :md="12" :lg="12" :xl="12">
            <div class="reservation-detail-inline">
              <span class="fs-14 secondary-text reservation-detail-label reservation-detail-label--inline">{{$t('reservation.qtyAvailableField')}}</span>
              <span class="fs-14 secondary-text reservation-detail-value reservation-detail-value--inline" v-if="selectedReservation.delayed || selectedReservation.intent">{{selectedReservation.qty - selectedReservation.quantity.qty_used}} {{$t('reservation.productInSupply')}}</span>
              <span class="fs-14 secondary-text reservation-detail-value reservation-detail-value--inline" v-else>{{selectedReservation.quantity.qty_available}}</span>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="reservation-detail-row" v-if="selectedReservation.comment!=null">
          <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="6">
            <span class="fs-14 secondary-text reservation-detail-label">{{$t('reservations.Commentaries')}}</span>
          </el-col>
          <el-col :xs="24" :sm="16" :md="12" :lg="12" :xl="12">
            <span class="fs-14 secondary-text">{{selectedReservation.comment}}</span>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane :label="salesName" name="salesOrders">
        <div v-if="!isMobile" class="reservation-sales-table-wrap scrollable only-x">
          <el-table
            v-loading="salesOrdersLoading"
            :data="salesOrders"
            :empty-text="$t('sales_orders.no_sales_orders')"
            class="reservation-sales-table"
            style="width: 100%"
          >
            <el-table-column prop="so_number" :label="$t('sales_orders.soNumber')" min-width="220">
              <template slot-scope="scope">
                <el-link @click="openSalesOrder(scope.row.id)">{{scope.row.so_number}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="customer_name" :label="$t('reservation.customerField')" min-width="320"></el-table-column>
            <el-table-column prop="qty_ordered" :label="$t('sales_orders.quantity')" min-width="170"></el-table-column>
            <el-table-column :label="$t('sales_orders.status')" min-width="180">
              <template slot-scope="scope">
                <SalesOrderStatusTag :status="scope.row.status" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-else v-loading="salesOrdersLoading" class="reservation-sales-mobile-list">
          <el-empty v-if="salesOrders == null || salesOrders.length === 0" :description="$t('sales_orders.no_sales_orders')" :image-size="64"></el-empty>
          <el-card v-for="so in salesOrders" :key="so.id" class="reservation-sales-mobile-card" shadow="never">
            <div class="reservation-sales-mobile-row">
              <span class="reservation-sales-mobile-label">{{ $t('sales_orders.soNumber') }}</span>
              <span class="reservation-sales-mobile-value">
                <el-link @click="openSalesOrder(so.id)">{{so.so_number}}</el-link>
              </span>
            </div>
            <div class="reservation-sales-mobile-row">
              <span class="reservation-sales-mobile-label">{{ $t('reservation.customerField') }}</span>
              <span class="reservation-sales-mobile-value">{{so.customer_name}}</span>
            </div>
            <div class="reservation-sales-mobile-row">
              <span class="reservation-sales-mobile-label">{{ $t('sales_orders.quantity') }}</span>
              <span class="reservation-sales-mobile-value">{{so.qty_ordered}}</span>
            </div>
            <div class="reservation-sales-mobile-row reservation-sales-mobile-row--status">
              <span class="reservation-sales-mobile-label">{{ $t('sales_orders.status') }}</span>
              <span class="reservation-sales-mobile-value reservation-sales-mobile-value--status">
                <SalesOrderStatusTag :status="so.status" />
              </span>
            </div>
          </el-card>
        </div>
      </el-tab-pane>
    </el-tabs>

    <ProductDetailDrawer :puid="selectedReservation.puid" direction="ltr" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer"></ProductDetailDrawer>
  </el-card>
</template>

<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import PortausLink from '@/components/portaus-link'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import ReservationInfos from '@/components/reservation/reservation-infos'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'
import ReservationAPI from '@/services/API/reservation'

export default {
  name: 'Reservation-view',
  props: {},
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      productDetailDrawerVisible: false,
      salesOrdersLoading: false,
      salesOrders: [],
      salesOrdersLoadedForId: null,
    };
  },
  components: {
    ProductDetailDrawer,
    PortausLink,
    UnitFormatVolumeLabel,
    ReservationInfos,
    SalesOrderStatusTag
  },
  methods: {
    closeProductDetailDrawer() {
      this.productDetailDrawerVisible = false;
    },
    openProductInfo() {
      this.productDetailDrawerVisible = true;
    },
    deleteReservation() {
      let message = "Le restant des produits (" + this.selectedReservation.quantity.qty_available + ") seront remis en disponibilite. Continuer?";
      if (this.selectedReservation.sales == null || this.selectedReservation.sales.length == 0) {
        message = "Ceci supprimera definitivement la reservation du systeme. Les produits (" + this.selectedReservation.quantity.qty_available + ") seront remis en disponibilite. Continuer?";
      }
      this.$confirm(message, 'Attention', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.deleteSelectedReservation()
          .then(() => {
            this.$emit('close');
          })
      }).catch(() => {})
    },
    editReservation() {
      this.$emit('edit');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    _moment(datetime, format = 'LL') {
      return moment(datetime).format(format);
    },
    openProvider(customerId) {
      var index = '/customers/' + customerId;
      this.$router.push(index);
    },
    openSalesOrder(salesOrderId) {
      var index = '/sales-orders/' + salesOrderId;
      this.$router.push(index);
    },
    handleTabClick(tabPane) {
      if (tabPane != null && tabPane.name === 'salesOrders') {
        this.fetchSalesOrders();
      }
    },
    fetchSalesOrders(force = false) {
      const reservationId = _.get(this.selectedReservation, 'id');
      if (reservationId == null) {
        this.salesOrders = [];
        return Promise.resolve();
      }

      if (!force && this.salesOrdersLoadedForId === reservationId) {
        return Promise.resolve();
      }

      this.salesOrdersLoading = true;
      return ReservationAPI.getReservationSalesOrders(reservationId)
        .then((rows) => {
          this.salesOrders = _.map(rows || [], (row) => ({
            id: row.id,
            so_number: row.so_number,
            customer_name: row.customer_name,
            qty_ordered: row.qty_ordered,
            status: {
              id: row.status_id,
              code: row.status_code,
            },
          }));
          this.salesOrdersLoadedForId = reservationId;
        })
        .catch(() => {
          this.salesOrders = [];
          this.salesOrdersLoadedForId = reservationId;
        })
        .finally(() => {
          this.salesOrdersLoading = false;
        });
    },
    ...mapActions('reservations', ['deleteSelectedReservation', 'setActiveTab']),
  },
  computed: {
    isB2B() {
      return _.get(this.selectedReservation, 'origin', null) === 'B2B';
    },
    inventoryName() {
      return _.get(this.selectedReservation, 'inventory.name');
    },
    isEditable() {
      let editable = !this.selectedReservation.completed;

      if (this.isRepCanModify || this.isCurrentUserAdmin) {
        return editable;
      }

      const ids = [];
      if (_.get(this.selectedReservation, 'fk_sales_rep_id') != null) {
        ids.push(_.get(this.selectedReservation, 'fk_sales_rep_id'))
      }
      ids.push(_.get(this.selectedReservation, 'createdBy.id'))

      const rep = _.find(ids, id => id === this.getCurrentUserId);
      if (rep == null) {
        editable = false
      }

      return editable;
    },
    salesName() {
      let name = this.$i18n.t('reservation.sales')
      if (this.selectedReservation != null) {
        const salesOrderLineIds = _.get(this.selectedReservation, 'salesOrderLineIds');
        const count = _.isArray(salesOrderLineIds)
          ? salesOrderLineIds.length
          : _.size(this.salesOrders);
        name += " (" + count + ")";
      }
      return name;
    },
    isMobile() {
      return this.window.width < 768;
    },
    height() {
      if (this.isMobile) return '';
      return "height :" + (this.window.height - 200) + "px"
    },
    tab: {
      set(activeTab) { this.setActiveTab(activeTab); },
      get() { return this.activeTab; }
    },
    ...mapState('reservations', ['selectedReservation', 'loading', 'selectedIndex', 'activeTab']),
    ...mapGetters('reservations', ['isNegative', 'isPositive', 'isIntermediary', 'selectedReservationlimitDate', 'customerName', 'isQuantityValid']),
    ...mapGetters(['isRepCanModify', 'getCurrentUserId', 'isCurrentUserAdmin']),
    ...mapGetters('salesOrders', ['selectedSalesOrderTagType'])
  },
  watch: {
    'selectedReservation.id'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.salesOrders = [];
        this.salesOrdersLoadedForId = null;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    if (this.activeTab === 'salesOrders') {
      this.fetchSalesOrders();
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.reservation-view-card {
  border-radius: 10px;
  border: 1px solid #e6edf5;
  box-shadow: 0 8px 20px rgba(37, 56, 88, 0.06);
}

.reservation-view-actions {
  position: relative;
  float: right;
  z-index: 1000;
}

.reservation-view-header {
  margin-bottom: 10px;
}

.reservation-view-title-content {
  display: inline-flex;
  align-items: center;
}

.reservation-view-b2b-logo {
  margin-left: 10px;
}

.reservation-warning {
  border-color: #f8d6d6;
  background: #fff8f8;
  margin-bottom: 8px;
}

.reservation-view-tabs {
  margin-top: 6px;
}

.reservation-detail-row {
  margin-top: 12px;
}

.reservation-detail-row--product {
  margin-top: 0;
}

.reservation-detail-label {
  font-weight: 600;
}

.reservation-detail-value {
  display: inline-block;
  text-align: right;
  width: 100%;
}

.reservation-detail-inline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.reservation-detail-label--inline {
  white-space: nowrap;
}

.reservation-detail-value--inline {
  width: auto;
  flex-shrink: 0;
}

.reservation-product-value {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.reservation-product-value .mdi-barcode-scan {
  margin-right: 5px;
  color: grey;
}

.reservation-product-sub {
  color: #909399;
}

.reservation-sales-mobile-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.reservation-sales-mobile-card {
  border: 1px solid #ebeef5;
}

.reservation-sales-mobile-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;
}

.reservation-sales-mobile-row:last-child {
  margin-bottom: 0;
}

.reservation-sales-mobile-label {
  color: #909399;
  font-size: 12px;
  flex: 0 0 42%;
  max-width: 42%;
}

.reservation-sales-mobile-value {
  flex: 1;
  min-width: 0;
  text-align: right;
  overflow-wrap: anywhere;
}

.reservation-sales-mobile-value--status {
  display: inline-flex;
  justify-content: flex-end;
}

.reservation-sales-mobile-row--status {
  flex-wrap: wrap;
}

.reservation-sales-mobile-row--status .reservation-sales-mobile-label {
  flex: 0 0 100%;
  max-width: 100%;
}

.reservation-sales-mobile-row--status .reservation-sales-mobile-value--status {
  flex: 0 0 100%;
  justify-content: flex-end;
}

.reservation-sales-table-wrap {
  width: 100%;
}

::v-deep .reservation-sales-table {
  min-width: 900px;
}

::v-deep .reservation-sales-table .cell {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
}

@media (max-width: 767px) {
  .reservation-view-card {
    padding: 10px 12px;
    border-radius: 10px;
  }

  .reservation-view-actions {
    float: none;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }

  .reservation-view-header {
    margin-bottom: 6px;
  }

  .reservation-detail-row {
    margin-top: 14px;
  }

  .reservation-detail-label--inline {
    max-width: 58%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
  }

  .reservation-detail-value--inline {
    font-size: 13px;
  }

  .reservation-product-value {
    margin-top: 2px;
  }

  ::v-deep .el-tabs__item {
    padding: 0 10px;
  }
}
</style>
